import { render } from "./Real_Service.vue?vue&type=template&id=0035bd17&scoped=true"
import script from "./Real_Service.vue?vue&type=script&lang=js"
export * from "./Real_Service.vue?vue&type=script&lang=js"

import "./Real_Service.vue?vue&type=style&index=0&id=0035bd17&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0035bd17"]])

export default __exports__